import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { REMOVE_DIMENSION } from './mutations';
import { growlActionSuccess } from '../../../utils/NotificationUtil';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';
import messages from './intl-messages';

const DeactivateDimension = ({
  sourceAccountId, targetAccountId, assessmentSection, dimension, growl, alreadyInUse, fetchData,
}) => {
  const [removeDimension] = useMutation(REMOVE_DIMENSION);
  const intl = useIntl();

  return (
    <>
      <Button
        type="button"
        className="p-button-secondary"
        icon="pi pi-lock"
        label={intl.formatMessage(messages.remove)}
        disabled={alreadyInUse}
        onClick={async () => {
          await removeDimension({
            variables: {
              input: {
                sourceAccountId,
                targetAccountId,
                assessmentSection,
                dimension,
              },
            },
          })
            .then(() => {
              growlActionSuccess(growl, intl.formatMessage(messages.removeDimensionSuccess));
              fetchData();
            })
            .catch(() => {
              growl.show({
                severity: 'error',
                detail: intl.formatMessage(messages.removeDimensionError),
                sticky: true,
              });
            });
        }
         }
      />
    </>
  );
};

DeactivateDimension.propTypes = {
  sourceAccountId: PropTypes.number.isRequired,
  targetAccountId: PropTypes.number.isRequired,
  assessmentSection: PropTypes.string.isRequired,
  dimension: PropTypes.string.isRequired,
  alreadyInUse: PropTypes.bool.isRequired,
  growl: growlShape.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export default withGrowl(DeactivateDimension);
